<template>
	<ul class="DTemp">
		<div @click="shows($event)" @mouseover="mouseover" @mouseout="mouseout" class='dtephover'>
			   <span class='tabspan' v-show="datas.possess == 'true'">
				{{show ? '▾' : '▸'}}
			</span>
			{{datas.label}}
			<div class="buts" >
				<el-button type="success" size="small"  @click="clicks(datas,1,index,$event)" v-if="datas.children" v-show="$store.getters.authority({name:'shopCategory',type:'add'})">新增</el-button>
				<el-button type="primary" size="small"  @click="clicks(datas,2,index,$event)" v-show="$store.getters.authority({name:'shopCategory',type:'update'})">编辑</el-button>
				<el-button type="danger" size="small" @click="clicks(datas,3,index,$event)" v-show="$store.getters.authority({name:'shopCategory',type:'delete'})">删除</el-button>
			</div>
		</div>
		<li v-if="datas.children" v-show="show">
			<class-list class="DTempList" v-for="(obj,i) of datas.children" :datas="obj" :index="index + i" :key="obj" @Click="clicks">
			</class-list>
		</li>
	</ul>
</template>
<script>
export default {
	name: 'class-list',
	data() {
		return {
			show: false,
			butShow: false,
		}
	},
	props: ['datas', 'index'],
	methods: {
		shows(e) {
			e.preventDefault();
			e.stopPropagation();
			this.show = this.show ? false : true;
			this.$emit('showHide');
		},
		refreshFun() {
			this.$emit('showHide');
		},
		mouseover() {
			this.butShow = true;
		},
		mouseout() {
			this.butShow = false;
		},
		clicks(obj, i, index, event) {
			event.preventDefault();
			event.stopPropagation();
			this.$emit('Click', obj, i, index, event)
		}
	},
	created(){
	}
}
</script>
<style lang="scss" scoped>
.DTemp {
	div {
		height: 50px;
		line-height: 50px;
		position: relative;
		font-size: 16px;
		padding-left: 30px;
		span {
			display: inline-block;
			font-size: 30px;
		}
		.tabspan {
			color: #bcbcbc;
			width: 20px;
          
		}
		.depticon {
            color:red;
			font-size:20px;
		}
		.buts {
			position: absolute;
			right: 20px;
			top: 0;
		}
	}
	.dtephover:hover{
		background-color:#f1f1f1;
	}
	li {
		padding-left: 30px;
	}
	.DTempList {
		position: relative;
		margin-left: 30px;
	}
	.DTempList:before {
		position: absolute;
		content: '';
		top: -10px;
		left: -20px;
		width: 40px;
		height: 40px;
		border-style: none none solid solid;
		border-width: 1px;
		border-color: #bcbcbc;
		z-index: 10;
	}
	.DTempList:not(:last-child):after {
		position: absolute;
		content: '';
		top:0;
		left: -20px;
		bottom: 0;
		border-style: none none none solid;
		border-width:1px;
		border-color: #bcbcbc;
		z-index: 10;
	}
}
</style>